// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"Clock_buttonsContainer__qE+z4","clock":"Clock_clock__ex1FN","watch":"Clock_watch__F7Ah1","more":"Clock_more__oz+68"};